/**
 * @generated SignedSource<<9ee14422a4a7138ed0f7a590ca94e85f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type AccountType = "COLLATERAL" | "CREDIT_CARD_COLLATERAL" | "DEFI_BORROW_COLLATERAL" | "DEFI_YIELD" | "FIAT" | "FIAT_SAVINGS" | "FUTURES_CFM" | "MULTISIG" | "MULTISIG_VAULT" | "PREDICTION_MARKETS_CFM" | "RAISE_INVESTMENTS" | "RETAIL_DEFI_LEND" | "STAKED_FUNDS" | "UNKNOWN" | "VAULT" | "WALLET" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type getIsCountryAllowedAccountFragment$data = {
  readonly type: AccountType;
  readonly " $fragmentType": "getIsCountryAllowedAccountFragment";
};
export type getIsCountryAllowedAccountFragment$key = {
  readonly " $data"?: getIsCountryAllowedAccountFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"getIsCountryAllowedAccountFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getIsCountryAllowedAccountFragment"
};

(node as any).hash = "67d0979ca1229f96a945043005d95e73";

export default node;
